import React from 'react'

import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

const GlobalNavFooter = ({ isLoggedIn, navigation, head }) => {
  if (isLoggedIn) {
    return <></>
  } 

  const footer = _get(navigation, 'globalNav.footer', {})
  if (_isEmpty(footer)) {
    return <></>
  } 

  if (head)
    return (
      <>
        <div
          data-testid="hc-globalNav-footer-head"
          dangerouslySetInnerHTML={{ __html: footer.headHtml || '' }}
        />
      </>
    )

  return (
    <>
      <div
        data-testid="hc-globalNav-footer-body"
        dangerouslySetInnerHTML={{ __html: footer.bodyHtml || '' }}
      />
    </>
  )
}

export default GlobalNavFooter
